import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  skipNav: {
    position: 'fixed',
    top: '70px',
    right: '30px',
    borderRadius: '20px',
    padding: '10px',
    display: 'inline-block',
    zIndex: '15',
    color: 'white',
    background: theme.palette.primary.main,
    opacity: '0',
    transform: 'translateY(-320%)',
    transition: 'transform .2s ease-out, opacity 0ms linear .2s',

    '&:focus': {
      transform: 'translateY(0)',
      transition: 'transform .2s ease-out',
      opacity: '1',
      color: 'white',
    },
  },
}))

/**
 * This component helps navigation to main content for accessiblity
 * @param {Object} props
 * @prop {String} skipNavId
 * @returns SkipNav component
 */
const SkipNav = ({ skipNavId }) => {
  const classes = useStyles()
  return !skipNavId ? null : (
    <a
      id="main-nav-skip-to-content"
      href={`#${skipNavId}`}
      className={classes.skipNav}
      aria-label="skip to main content"
    >
      Skip to main content
    </a>
  )
}

SkipNav.propTypes = {
  skipNavId: PropTypes.string,
}

export default SkipNav
